var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sl-medal count-box"},[_c('h2',[_vm._v("Total Plans")]),_c('h1',[_vm._v(_vm._s(_vm.count))])])
}
var staticRenderFns = []

export { render, staticRenderFns }